import { z } from 'zod';

export type IntercomProductCategoryRecord = {
	[key: `cat_${number}`]: string;
};

export type IntercomProfile = {
	app_id: string;
	name: string;
	email: string;
	subdomain: string;
	user_id: string;
	cf_version: string;
	country?: string;
	commission?: string;
} & IntercomProductCategoryRecord;

export const intercomProductCategorySchema: z.ZodType<IntercomProductCategoryRecord> = z.record(
	z.string().regex(/^cat_\d+$/),
	z.string(),
);

export const intercomProfileSchema: z.ZodType<IntercomProfile> = z.object({
	app_id: z.string(),
	name: z.string(),
	email: z.string(),
	subdomain: z.string(),
	user_id: z.string(),
	cf_version: z.string(),
	country: z.string().optional(),
	commission: z.string().optional(),
});

export const productCategoriesToIntercomFormat = (categories: string[]) => {
	return intercomProductCategorySchema.safeParse(categories.reduce((record, category, index) => {
		return { ...record, [`cat_${index + 1}`]: category };
	}, {} as IntercomProductCategoryRecord)).data;
};
